import React, {Fragment} from "react";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";

export class DropSelection extends React.Component {
  constructor(props) {
    super(props);
  }

  clickHere(key, item) {
    this.props.onClick && this.props.onClick(key, item)
  }

  renderCategory(category, key) {
    return <Fragment>
      <DropdownItem header>{category.header}</DropdownItem>
      {(category.options || []).map((item, index) => {
        const itemDisplay = item.display || item;
        const itemValue = item.value || item;
        return <DropdownItem key={`${key}-${index}`}
                             onClick={() => this.clickHere(key, itemValue)}>{itemDisplay}</DropdownItem>
      })}
    </Fragment>
  }

  render() {

    const buttonStyle = !!this.props.hideButton ? {
      backgroundColor: "#fff",
      height: 16,
      padding: 0,
      margin: 0,
      borderStyle: "none"
    } : {}

    const isBold = !!this.props.bold;

    !!this.props.noPadding && (buttonStyle.padding = 0);

    const items = this.props.items || {};

    return (
      <UncontrolledDropdown>
        <DropdownToggle className={"text"} caret={true}
                        style={buttonStyle}>
          {isBold ?
            <strong>{this.props.displayText}</strong>
            :
            <React.Fragment>{this.props.displayText}</React.Fragment>
          }
        </DropdownToggle>
        <DropdownMenu style={{overflowY: "auto", maxHeight: 250}}>
          {Object.keys(items).map((item, i) => {
            return <Fragment key={`${i}`}>
              {this.renderCategory(items[item], item)}
            </Fragment>
          })}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Leads/components/DropSelection.js